import React, { memo } from 'react';
import styled from 'styled-components';
import Skeleton from '@pedidosya/web-fenix/system/Skeleton';

const Container = styled.div`
  height: 38px;
  display: flex;
  padding: 26px 16px;
`;

const Brand = styled.div`
  width: 60%;
  display: flex;
`;

const Pills = styled.div`
  width: 40%;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

const BrandHeaderShimmer = () => (
  <Container>
    <Brand>
      <Skeleton height="12" width="12" shape="circle" />
    </Brand>
    <Pills>
      <Skeleton height="6" width="6" />
      <Skeleton height="6" width="6" />
    </Pills>
  </Container>
);

export default memo(BrandHeaderShimmer);
